import {
  Drawer,
  Toolbar,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Typography,
  ListItemText,
  Avatar,
  useTheme,
} from "@material-ui/core";

// import * as Muicon from "@material-ui/icons";
import { useHistory, useLocation } from "react-router-dom";

import { Accordion, AccordionDetails, AccordionSummary } from "./Accordion";
import { sideStyles } from "../styles/sideBarStyle";
import React from "react";
import { connect } from "react-redux";
import Store from "../redux/Store";
import { officeAuth } from "../redux/Login/LoginActionCreators";
import Pishkhan from "../img/home.png";
import {
  ArrowForwardIos,
  EventNoteOutlined,
  ExpandMoreOutlined,
  MenuBook,
  ReceiptOutlined,
  DonutLarge,
  ContactSupportOutlined,
  EmailOutlined,
  AssessmentOutlined,
} from "@material-ui/icons";
const menu_icons = [
  { title: "EventNoteOutlined", icon: EventNoteOutlined },
  { title: "ReceiptOutlined", icon: ReceiptOutlined },
  { title: "MenuBook", icon: MenuBook },
  { title: "ContactSupportOutlined", icon: ContactSupportOutlined },
  { title: "EmailOutlined", icon: EmailOutlined },
  { title: "AssessmentOutlined", icon: AssessmentOutlined },
];
const SideBar = ({
  width,
  sideStatus,
  setSideStatus,
  activeOrders,
  readyToSendOrders,
  rejectedOrders,
}) => {
  const GenerateIcon = (variation, props = {}) => {
    const IconName =
      menu_icons.find((icon) => icon.title === variation).icon || DonutLarge;
    return <IconName {...props} />;
  };
  const theme = useTheme();
  const classes = sideStyles();
  const history = useHistory();
  const location = useLocation();
  const [expand, setExpand] = React.useState("سفارش ها");
  const handleChange = (panel) => (event, isExpanded) => {
    setExpand(isExpanded ? panel : false);
  };
  const clear = () => {
    history.push("/");
    localStorage.clear();
    Store.dispatch(officeAuth(false));
  };

  let menu;
  try {
    menu = JSON.parse(localStorage.menu);
    // menu.push(transaction);
  } catch (error) {
    clear();
  } 
  return (
    <Drawer
      open={sideStatus}
      variant={width > 1280 ? "permanent" : "temporary"}
      anchor="left"
      className={classes.Drawer}
      classes={{ paper: classes.Drawer }}
      onClose={() => {
        setSideStatus(false);
      }}
    >
      <Toolbar dir="ltr" style={{ padding: 14 }}>
        <IconButton
          size="small"
          onClick={() => {
            setSideStatus(false);
          }}
        >
          <ArrowForwardIos fontSize="small" style={{ fontSize: 16 }} />
        </IconButton>
      </Toolbar>
      <List style={{ padding: "0", overflow: "hidden" }}>
        <ListItem
          onClick={() => {
            history.push("/");
          }}
          button={location.pathname === "/" ? false : true}
          style={{ height: "3em", padding: 0, width: 275 }}
          className={location.pathname === "/" ? classes.activelistItem : null}
        >
          <ListItemIcon>
            <IconButton
              style={{
                color: location.pathname === "/" ? "white" : null,
                position: "relative",
                right: 16,
              }}
            >
              <img src={Pishkhan} alt="" />
            </IconButton>
          </ListItemIcon>
          <ListItemText style={{ position: "relative", right: 14 }}>
            <Typography variant="body1">پیشخوان</Typography>
          </ListItemText>
        </ListItem>
      </List>
      {menu
        ? menu?.map((item, index) => {
            if (item.menu_subs) {
              return (
                <Accordion
                  expanded={expand === item.title}
                  onChange={handleChange(item.title)}
                  elevation={0}
                  style={{ width: "100%", borderTop: "1px solid #c9c9c9" }}
                  // className={classes.drawer}

                  key={index}
                >
                  <AccordionSummary
                    style={{ height: "3em", padding: "4.5%" }}
                    expandIcon={
                      <ExpandMoreOutlined
                        color={expand === item.title ? "primary" : "inherit"}
                      />
                    }
                  >
                    <List>
                      <ListItem style={{ padding: "0" }}>
                        <ListItemIcon>
                          <IconButton
                            color={
                              expand === item.title ? "primary" : "default"
                            }
                          >
                            {GenerateIcon(item?.icon)}
                          </IconButton>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography
                            color={
                              expand === item.title ? "primary" : "textPrimary"
                            }
                            variant="body1"
                          >
                            {item.title}
                          </Typography>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </AccordionSummary>
                  <AccordionDetails style={{ padding: "0" }}>
                    <List style={{ padding: "0", width: "100%" }}>
                      {item.menu_subs.map((item, index) => {
                        if (
                          item.link === "system-manegment/users-group" ||
                          item.link === "system-manegment/accessibilities"
                        ) {
                          item.enabled = false;
                        }

                        return (
                          <ListItem
                            onClick={() => {
                              history.push(`/${item.link}`);
                              setSideStatus(false);
                            }}
                            disabled={!item.enabled}
                            key={index}
                            style={{
                              paddingRight: "60px",
                            }}
                            button={
                              location.pathname.indexOf(item.link) > -1
                                ? false
                                : true
                            }
                            className={
                              location.pathname.indexOf(item.link) > -1
                                ? classes.activelistItem
                                : null
                            }
                          >
                            <ListItemText>
                              <Typography variant="body1">
                                {item.title}
                              </Typography>
                            </ListItemText>
                            {item.link === "orders/newOrders" ||
                            item.link === "orders/rejected_delivery" ||
                            item.link === "orders/readyToSend" ? (
                              <Avatar
                                className={classes.Avatar}
                                style={{
                                  backgroundColor: "white",
                                  color:
                                    location.pathname !== `/${item.link}`
                                      ? theme.palette.primary.main
                                      : theme.palette.primary.main,
                                  padding: "17px",
                                  paddingTop: "20px",
                                  marginRight: "0px",
                                  border:
                                    location.pathname !== `/${item.link}`
                                      ? `1px solid ${theme.palette.primary.main}`
                                      : theme.palette.primary.main,
                                }}
                              >
                                {item.link === "orders/newOrders" &&
                                  activeOrders.length}
                                {item.link === "orders/rejected_delivery" &&
                                  rejectedOrders.length}
                                {item.link === "orders/readyToSend" &&
                                  readyToSendOrders.length}
                              </Avatar>
                            ) : null}
                          </ListItem>
                        );
                      })}
                    </List>
                  </AccordionDetails>
                </Accordion>
              );
            } else {
              return (
                <List key={index} style={{ padding: "2%" }}>
                  <ListItem
                    button={
                      location.pathname === `/${item.link}` ? false : true
                    }
                    className={
                      location.pathname === `/${item.link}`
                        ? classes.activelistItem
                        : null
                    }
                  >
                    <ListItemIcon>
                      <IconButton
                        size="small"
                        color={
                          item.link === location.pathname
                            ? "primary"
                            : "default"
                        }
                      >
                        {GenerateIcon(item.icon)}
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      style={{ position: "relative", left: "7px" }}
                      onClick={() => history.push(`/${item.link}`)}
                    >
                      <Typography variant="body1">{item.title}</Typography>
                    </ListItemText>
                  </ListItem>
                </List>
              );
            }
          })
        : clear()}
    </Drawer>
  );
};

const mapStateToProps = (props) => {
  const { OrderReducer } = props;
  const { activeOrders, readyToSendOrders, rejectedOrders } = OrderReducer;
  return { activeOrders, readyToSendOrders, rejectedOrders };
};

export default connect(mapStateToProps)(SideBar);
// let transaction = {
//   title: "تراکنش ها",
//   icon: "AccountBalance",
//   link: "",
//   enabled: true,
//   menu_subs: [
//     {
//       title: "تراکنش ها",
//       icon: "",
//       link: "orders/transactions",
//       enabled: true,
//     },
//   ],
// };
